import { ISorter } from './SortersInterface';
import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getSorters = async (force: boolean = false) => {
  let sorters = storage.getSorters();
  if (!sorters || sorters.length === 0 || force) {
    const url = `${getFunctionBaseUrl()}/api/getSorters`;
    const response: ISorter[] = await rest.get(url);
    sorters = response;
    storage.setSorters(sorters);
  }
  return sorters;
}